import { useEffect } from 'react';

import log from 'loglevel';

import { useSmartDataFetch } from './useSmartDataFetch';
import { VIEW_TYPES } from '../../enums/viewTypes';
import { useIntegrationsStore, useRefreshUnreads } from '../../store';

export const useFetchSidebarCounters = (enabled: boolean) => {
  const { refreshUnreads } = useRefreshUnreads();
  const { fetchViewType } = useSmartDataFetch();
  const fetchEmailFilters = useIntegrationsStore(
    (state) => state.currentEmailFilters,
  );
  const serializedFilters = JSON.stringify(fetchEmailFilters);

  useEffect(() => {
    if (!enabled) return;

    const fetchCounters = async () => {
      try {
        await Promise.all([
          refreshUnreads(),
          fetchViewType(VIEW_TYPES.DRAFT, fetchEmailFilters),
          fetchViewType(VIEW_TYPES.PRIMARY, fetchEmailFilters),
        ]);
      } catch (error) {
        log.error(
          '[useFetchSidebarCounters] Error fetching sidebar counters:',
          error,
        );
      }
    };

    fetchCounters();
  }, [enabled, serializedFilters]);
};
